import { useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import {useSelector} from "react-redux";
import {loadCompanyProductCatalogsAsync, selectCompanyCatalogs} from "../../../../app/store/reducers/roaming/roamingReducer";
import {selectLang, Translate} from "../../../../app/store/reducers/main/mainReducer";
import { debounce } from 'underscore';
import { selectActiveOrganization } from '../../../../app/store/reducers/auth/authReducer';
import roamingService from '../../../../services/roaming/roamingService';

const formatOptionLabel = (option) => {
    return (
        <div className="fs--1">
            <span className="text-black fw-bold me-1">{option.class_code}</span>-
            <span className="ms-1 text-facebook">{option.name}</span>
        </div>
    )
}
const SelectOrganizationCatalog = ({onChange, selectProps}) => {
    const t = Translate;
    const lang = useSelector(selectLang);
    const companyCatalogs = useSelector(selectCompanyCatalogs);

    const activeOrganization = useSelector(selectActiveOrganization)

    const loadOptions = async (inputValue, callback) => {
        const catalogs = (await roamingService.getCompanyProductCatalog(activeOrganization.inn, lang, inputValue)).data
        callback(catalogs)
    };
    useEffect(()=> {
        loadCompanyProductCatalogsAsync(activeOrganization.inn, lang)
    }, [activeOrganization.inn, lang])
    const debouncedLoadOptions = debounce(loadOptions, 500);
    return (
        <AsyncSelect isClearable
                     defaultOptions={companyCatalogs}
                     loadOptions={debouncedLoadOptions}
                     hideSelectedOptions
                     getOptionLabel={option => option.class_code}
                     getOptionValue={option => `${option.class_code} ${option.name}`}
                     formatOptionLabel={formatOptionLabel}
                     classNamePrefix="select"
                     placeholder={t(lang, 'items.common.select')}
                     onChange={onChange}
                     value={null}
                     {...selectProps}
        />
    );
};

export default SelectOrganizationCatalog;
